<script setup>
/* eslint-disable no-unused-vars */
import _ from 'lodash';
import axios from '@/plugins/axios.js';
import domtoimage from 'dom-to-image-more';
import { saveAs } from 'file-saver';
import $ from 'jquery';
import { useStore } from "vuex";
import { computed, watch } from 'vue';
import LineChart from "@/examples/Charts/LineChart.vue";
import BarChart from "@/examples/Charts/BarChart.vue";
import BarChartHorizontal from "@/examples/Charts/BarChartHorizontal.vue";
import TableData from "@/examples/TableData.vue";
import DoughnutChart from "@/examples/Charts/DoughnutChart.vue";
import PolarChart from "@/examples/Charts/PolarChart.vue";
import RadarChart from "@/examples/Charts/RadarChart.vue";
import BubbleChart from "@/examples/Charts/BubbleChart.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
//import eChart from '@/examples/Charts/Echart.vue';
//import PolarCategory from '@/examples/Charts/PolarCategory.vue';

const components = {
  'LineChart': LineChart,
  'BarChart': BarChart,
  'TableData': TableData,
  'BarChartHorizontal': BarChartHorizontal,
  'DoughnutChart': DoughnutChart,
  'PolarChart': PolarChart,
  'RadarChart': RadarChart,
  'BubbleChart': BubbleChart,
//  'eChart': eChart,
//  'PolarCategory': PolarCategory
}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const toggleFullscreen = (widget) => {
    widget.fullscreen = !widget.fullscreen;
    store.commit("setSidenav", !widget.fullscreen);
};

const waitingAnalisi = computed(() => {
    return store.getters['jai/waitingAnalisi'];
});

const waitingSave = computed(() => {
    return store.getters['jai/waitingSave'];
});

const download = () => {
//    var div_container = document.getElementById('widget_div');
    var table = $("#widget_div").find('table')[0];
    console.log($("#widget_div"));
    console.log(table);
    domtoimage.toBlob(table).then(function (blob) {
        saveAs(blob, 'widget.png');
    });
};

const analizza = () => {
    var table = $("#widget_div").find('table')[0];
    console.log($("#widget_div"));
    domtoimage.toBlob(table).then(function (blob) {
        var formData = new FormData();
        formData.append("file_widget", blob);
        axios.post("/jai/analizza/widget", formData)
        .then((response) => {
            var data = JSON.parse(response.data);
            console.log(data);
            currentWidget.value.analisi = data;
        }); 
    });
};

const analizzaCorrelation = () => {
    store.commit('jai/setWaitingAnalisi', true);
    var table = $("#correlation_div").find('table')[0];
    console.log($("#correlation_div"));
    domtoimage.toBlob(table).then(function (blob) {
        var formData = new FormData();
        formData.append("file_widget", blob);
        axios.post("/jai/analizza/widget", formData)
        .then((response) => {
            var data = JSON.parse(response.data);
            console.log(data);
            currentWidget.value.correlation_analisi = data;
            store.commit('jai/setWaitingAnalisi', false);
        }); 
    });
};

const analizzaQuery = () => {
    store.commit('jai/setWaitingAnalisi', true);
    var table = $("#query_div").find('table')[0];
    console.log($("#query_div"));
    domtoimage.toBlob(table).then(function (blob) {
        var formData = new FormData();
        formData.append("file_widget", blob);
        axios.post("/jai/analizza/widget", formData)
        .then((response) => {
            var data = JSON.parse(response.data);
            console.log(data);
            currentWidget.value.query_analisi = data;
            store.commit('jai/setWaitingAnalisi', false);
        }); 
    });
};

const salvaWidget = () => {
    store.commit('jai/setWaitingSave', true);
    axios.post("/jai/save/widget", currentWidget.value)
    .then((response) => {
        if(_.has(response.data, 'error')) {
            store.commit('jai/setErrorMessage', response.data.error);
        } else {
            store.commit('jai/setSuccessMessage', response.data);
        }
        store.commit('jai/setWaitingSave', false);
    }); 
};

const currentWidget = computed(() => {
    return store.getters['jai/currentWidget'] ? store.getters['jai/currentWidget'] : false;
});

watch(() => currentWidget.value.type, () => { 
    if(currentWidget.value.type == 'tabella') {
        currentWidget.value.component = 'TableData';
    } else {
        if(currentWidget.value) {
            currentWidget.value.component = null;
        }
    }
});

const payload = computed(() => {
    if(currentWidget.value.type == 'tabella') {
        return {
            fields: _.filter(_.keys(currentWidget.value.results[0]), function (item) {
                return item != 'player_id' && item != 'team_id';
            }),
            items: currentWidget.value.results
        }
    }
    return null;
});

const payload_correlation = computed(() => {
    if(currentWidget.value.correlation_results && _.isArray(currentWidget.value.correlation_results) && currentWidget.value.correlation_results.length > 0) {
        return {
            fields: _.filter(_.keys(currentWidget.value.correlation_results[0]), function (item) {
                return item != 'player_id' && item != 'team_id';
            }),
            items: currentWidget.value.correlation_results
        }
    }
    return null;
});

const payload_top_players = computed(() => {
    if(currentWidget.value.top_players && _.isArray(currentWidget.value.top_players) && currentWidget.value.top_players.length > 0) {
        return {
            fields: _.filter(_.keys(currentWidget.value.top_players[0]), function (item) {
                return item != 'player_id' && item != 'team_id';
            }),
            items: currentWidget.value.top_players
        }
    }
    return null;
});

const payload_query = computed(() => {
    if(currentWidget.value.query_results && _.isArray(currentWidget.value.query_results) && currentWidget.value.query_results.length > 0) {
        return {
            fields: _.filter(_.keys(currentWidget.value.query_results[0]), function (item) {
                return item != 'player_id' && item != 'team_id';
            }),
            items: currentWidget.value.query_results
        }
    }
    return null;
});

const colors = [
    "#00B386",
    "#2EC85B",
    "#7BDE3C",
    "#B8F100",
    "#E9F700",
    "#FFF300",
    "#FFDB00",
    "#FFB800",
    "#FF8900",
    "#FF0059",
];

const colors_rgb = [
    "rgba(0, 179, 134, 0.7)",
    "rgba(46, 200, 91, 0.7)",
    "rgba(123, 222, 60, 0.7)",
    "rgba(184, 241, 0, 0.7)",
    "rgba(233, 247, 0, 0.7)",
    "rgba(255, 243, 0, 0.7)",
    "rgba(255, 219, 0, 0.7)",
    "rgba(255, 184, 0, 0.7)",
    "rgba(255, 137, 0, 0.7)",
    "rgba(255, 0, 89, 0.7)",
];

const widgets = [
    { x: 0, y: 0, w: 4, h: 8, i: 'chart-line-0', title: 'Line Chart',  component: 'LineChart', fullscreen: false, payload: {
        labels: [
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
            ],
        datasets: [
        {
            label: 'Dataset 1',
            data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
            borderColor: colors[2],
            backgroundColor: colors[2], 
            tension: 0.4
        },
        {
            label: 'Dataset 2',
            data: [34, 63, 200, 110, 350, 120, 230, 110, 640],
            borderColor: colors[5], 
            backgroundColor: colors[5], 
            tension: 0.4
        },
        ],
    }},
/*  { x: 0, y: 0, w: 4, h: 8, i: 'chart-line-0', title: 'Line Chart',  component: 'eChart', fullscreen: false, payload: {
  xAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: [820, 932, 901, 934, 1290, 1330, 1320],
      type: 'line',
      smooth: true
    }
  ]
}},  */
/*    { x: 0, y: 0, w: 4, h: 8, i: 'chart-line-0', title: 'Polar Chart',  component: 'PolarCategory', fullscreen: false, payload: {
  xAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: [820, 932, 901, 934, 1290, 1330, 1320],
      type: 'line',
      smooth: true
    }
  ]
}},  */
    { x: 4, y: 0, w: 4, h: 8, i: 'chart-bar-1', title: 'Bar Chart', component: 'BarChart', fullscreen: false, payload: {
    labels: [
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
        borderColor: colors[8],
        backgroundColor: colors[8], 
    },
    {
        label: 'Dataset 2',
        data: [34, 63, 200, 110, 350, 120, 230, 110, 640],
        borderColor: colors[1],
        backgroundColor: colors[1], 
    },
    ],
}},
    { x: 8, y: 0, w: 4, h: 8, i: 'table-data-2', title: 'Simple Data Table', component: 'TableData', fullscreen: false, payload: {
        fields: ['player', 'team', 'goals', 'assists'],
        items: [{ player: 'Pinco Pallino', player_id: 1649, team: 'Rossi', team_id: 45, goals: 5, assists: 3 },{ player: 'Mario Rossi', player_id: 1367, team: 'Gialli', team_id: 189, goals: 8, assists: 7 }, { player: 'Paolo Verdi', player_id: 8177, team: 'Arancioni', team_id: 196,  goals: 0, assists: 3 }, { player: 'Pinco Pallino', player_id: 6987, team: 'Rossi', team_id: 138, goals: 5, assists: 3 },{ player: 'Mario Rossi', player_id: 4495, team: 'Gialli', team_id: 212, goals: 8, assists: 7 }, { player: 'Paolo Verdi', player_id: 3576, team: 'Arancioni', team_id: 127, goals: 0, assists: 3 }],
    } },
    { x: 0, y: 3, w: 4, h: 8, i: 'chart-bar-horizontal-3', title: 'Bar Chart Horizontal', component: 'BarChartHorizontal', payload: {
    labels: [
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [500, 450, 400, 350, 300, 250, 200, 150, 100, 50],
        borderColor: colors,
        backgroundColor: colors, 
    },
/*    {
        label: 'Dataset 2',
        data: [34, 63, 200, 110, 350, 120, 230, 110, 640],
        borderColor: colors[3],
        backgroundColor: colors[3], 
    },  */
    ],
}},
    { x: 4, y: 3, w: 4, h: 8, i: 'chart-pie-4', title: 'Doughnut Chart', component: 'DoughnutChart', fullscreen: false, payload: {
    labels: [
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [420, 350, 300, 220, 500, 250, 400, 230, 500, 250],
   //     borderColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: colors, 
        backgroundColor: colors, 
        hoverOffset: 5
    },
    ],
} },
    { x: 8, y: 3, w: 4, h: 8, i: 'chart-polar-5', title: 'Polar Chart', component: 'PolarChart', fullscreen: false, payload: {
    labels: [
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [420, 350, 300, 220, 500, 250, 400, 230, 500, 250],
        borderColor: colors_rgb, 
        backgroundColor: colors_rgb, 
        hoverOffset: 5
    },
    ],
} },
    { x: 0, y: 6, w: 4, h: 8, i: 'chart-radar-6', title: 'Radar Chart', component: 'RadarChart', fullscreen: false, payload: {
    labels: [
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [270, 480, 300, 390, 500, 600, 400, 340, 500],
        borderColor: colors_rgb[2],
        backgroundColor: colors_rgb[2], 
    },
    {
        label: 'Dataset 2',
        data: [430, 380, 590, 450, 350, 510, 530, 540, 640],
        borderColor: colors_rgb[7],
        backgroundColor: colors_rgb[7], 
    },
    ],
} },
    { x: 4, y: 6, w: 4, h: 8, i: 'chart-mixed-7', title: 'Mixed Chart', component: 'BarChart', fullscreen: false, payload: {
    labels: [
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
        ],
    datasets: [
    {
        label: 'Dataset 1',
        data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
        borderColor: colors[8],
        backgroundColor: colors[8], 
        type: 'line',
        tension: 0.4,
    },
    {
        label: 'Dataset 2',
        data: [34, 63, 200, 110, 350, 120, 230, 110, 640],
        borderColor: colors[3],
        backgroundColor: colors[3], 
    },
    ],
} },
    { x: 8, y: 6, w: 4, h: 8, i: 'chart-bubble-8', title: 'Bubble Chart', component: 'BubbleChart', fullscreen: false, payload: {
    datasets: [
    {
        label: 'Dataset 1',
        data: [{
            x: 50,
            y: 34,
            r: 15
        }, {
            x: 40,
            y: 63,
            r: 10
        }, {
            x: 300,
            y: 200,
            r: 10
        }, {
            x: 220,
            y: 110,
            r: 12
        },{
            x: 350,
            y: 500,
            r: 12
        }, {
            x: 150,
            y: 400,
            r: 10
        }],
        borderColor: colors[9],
        backgroundColor: colors_rgb[9], 
    },
    {
        label: 'Dataset 2',
        data: [{
            x: 500,
            y: 350,
            r: 15
        }, {
            x: 250,
            y: 120,
            r: 10
        }, {
            x: 400,
            y: 230,
            r: 9
        }, {
            x: 500,
            y: 640,
            r: 12
        } , {
            x: 400,
            y: 150,
            r: 10
        }],
        borderColor: colors[4],
        backgroundColor: colors_rgb[4], 
    },
    ],
}}, 
    ] 
</script>
<template>
<div class="py-4 container-fluid">
<div class="row">
<div class="col-lg-12">

<div class="row" v-if="currentWidget && !currentWidget.id">
<div class="col-12 mb-4">
<div class="card">
<div class="card-header pb-0">
<div class="d-flex align-items-center justify-content-between">
<h6 class="mb-0">Nuovo Widget</h6>
<div>
<argon-button color="success" size="sm" class="ms-auto me-2" v-if="currentWidget && (payload_correlation || payload_query)" @click.stop="salvaWidget" :disabled="waitingSave">Salva</argon-button>
<argon-button color="secondary" size="sm" class="ms-auto me-2" @click.stop="store.commit('jai/setWidget', null)">Chiudi</argon-button>
<argon-button color="info" size="sm" class="ms-auto" @click.stop="analizza" v-if="false">Analizza</argon-button>

</div>
</div>
</div>
<div class="card-body">

    <div v-if="payload_correlation" id="correlation_div">
        <div class="row">
        <div class="col"><h6>Correlation Results</h6></div>
        <div class="col text-end mb-2"><argon-button size="sm" class="mx-2" data-bs-toggle="modal" data-bs-target="#exampleModal">Top Players</argon-button><argon-button color="danger" size="sm" @click.stop="analizzaCorrelation" :disabled="waitingAnalisi">Analizza <i class="spinner-border spinner-border-sm ms-2" aria-hidden="true" v-if="waitingAnalisi"></i></argon-button></div>
        </div>
        <TableData id="p_c" :payload="payload_correlation"/>
        <div v-if="currentWidget && currentWidget.correlation_analisi" class="border p-2"><pre style="white-space: pre-wrap;">{{ currentWidget.correlation_analisi.message.content }} </pre></div>
        
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Top Players</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <TableData id="t_p" :payload="payload_top_players"/>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Chiudi</button>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div v-if="payload_query" id="query_div"><hr/>
        <div class="row">
        <div class="col"><h6>Query Results</h6></div>
        <div class="col text-end"><argon-button color="danger" size="sm" @click.stop="analizzaQuery" :disabled="waitingAnalisi" class="ms-2">Analizza <i class="spinner-border spinner-border-sm ms-2" aria-hidden="true" v-if="waitingAnalisi"></i></argon-button></div>
        </div>
        <TableData id="p_q" :payload="payload_query"/>
        <div v-if="currentWidget && currentWidget.query_analisi" class="border p-2"><pre style="white-space: pre-wrap;">{{ currentWidget.query_analisi.message.content }} </pre></div>
    </div>

    <hr/>
    <h6>JSON Response</h6>
    <pre>{{ currentWidget }}</pre>

<!--div class="row">

<div class="col-9">


<label class="form-control-label">Titolo</label>
<argon-input type="text" v-model="currentWidget.title" />

<div id="widget_div">
    <component id="new_widget" :is="components[currentWidget.component]" :payload="payload"/>
</div>

</div>

<div class="col-3">
<label class="form-control-label">Tipo di rappresentazione</label>
<div class="d-flex">
<argon-radio id="tb" class="me-2" v-model="currentWidget.type" name="widget_type" value="tabella" :checked="currentWidget.type == 'tabella'">Tabella</argon-radio>
<argon-radio id="gr" v-model="currentWidget.type" name="widget_type" value="grafico" :checked="currentWidget.type == 'grafico'">Grafico</argon-radio>
</div>
<div v-if="currentWidget.analisi"><pre style="white-space: pre-wrap;">{{ currentWidget.analisi.message.content }} </pre></div>
</div>

</div-->

</div>
</div>
</div>
</div>

<smart-widget-grid :layout="widgets">
<template v-slot:[widget.i] v-for="widget in widgets" :key="widget.i">
<smart-widget :title="widget.title" :fullscreen="true" @before-fullscreen="toggleFullscreen(widget)">

<template v-slot:toolbar>
<div style="margin: 0 12px;" v-if="widget.fullscreen">
<argon-button color="success" size="sm" class="px-3 me-2"><i class="fa fa-pencil" aria-hidden="true"></i></argon-button>
<argon-button color="danger" size="sm" class="px-3"><i class="fa fa-trash" aria-hidden="true"></i></argon-button>
</div>
</template>

<template v-slot="{contentH}">
    <div class="content-widget">
        <component :is="components[widget.component]" :payload="widget.payload" :id="widget.i" :contentHeight="contentH" :darkMode="darkMode"/>                                                  
    </div>
</template>

</smart-widget>
</template>
</smart-widget-grid>


</div>
</div>
</div>
</template>
